import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled, { css } from 'styled-components';

import { breakpoints } from '../../../lib/constants';
import { FlexContainerRow } from '../skylab/page';

export const BuyNowButtonContainer = styled.div`
  margin-top: 40px;
  text-align: center;

  button {
    margin-bottom: 15px;
  }

  .terms-link {
    margin-top: 15px;
  }

  p {
    padding-top: 50px;
  }
   img {
    height: 50px;
  }
`;

export const CartContainer = styled.div`
  margin-bottom: -30px;

  @media (max-width:${breakpoints.phone}px) {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const CartInformation = styled.div`
  background: ${COLORS.lightestGray};
  height: auto;
  padding: 20px;
  ${(props: { forceMobile?: boolean }) => (props.forceMobile ? 'margin-top: 20px;' : null)}
`;

export const CartImagePrice = styled(FlexContainerRow)`
  align-items: center;
  justify-content: center;
  margin-bottom: 3px;
  font-weight: 600;
  && {
    img {
      display: inline;
      float: left;
      max-height:30px;
      max-width: 25px;
      margin-right: 10px;
    }
  }
  > * {
    margin-right: 5px;
    &:last-child {
      margin-bottom: 0;
      margin-top: -3px;
      text-align: right;
    }
  }

  @media (max-width:869px) {
    > * {
      &:last-child {
        margin-right: 15px;
      }
    }
  }

  @media (max-width:${breakpoints.phone}px) {
    padding: 15px;
  }
`;

export const LogoText = styled.p`
  font-size: 1.285em;
  font-weight: 400;
  && {
    margin-bottom: 0;
    margin-top: 2px;
  }
`;

export const PlanContainer = styled.div`
  background: #FFF;
  padding: 30px;
  position: relative;
  min-height: 230px;

  @media (max-width:${breakpoints.phone}px) {
    padding: 15px;
  }
`;

const CartDetails = styled.p`
  font-size: 12px;
  font-style: normal;
  padding-left: 10px;
  && {
    margin-bottom: 0;
  }
`;

export const DeflectionWording = styled.p`
  text-align: center;
`;

export const CartActivationFee = styled(CartDetails)`
  > span {
    font-weight: 600;
    float: right;
    font-size: .875rem;

    &:first-child {
      margin: 0 5px;
    }
  }

  strike {
    text-decoration: line-through;
  }
`;

export const CartPlanDetails = styled(CartDetails)`
  font-size: .875rem;
  && {
    margin-bottom: 0;
  }

  > span {
    font-weight: 600;
  }

  &::before {
    content: "Plan: ";
    display: inline-block;
    font-style: normal;
    margin-right: 5px;
  }
`;

export const CartRenewalDetails = styled(CartPlanDetails)`
  &::before {
    content: "Renews: ";
    margin-bottom: 10px;
  }
`;

export const TotalPriceContainer = styled(FlexContainerRow)`
  display: flex;
  flex-direction: column;
  position: relative;
  bottom: 0px;
  left: 0px;
  width: 100%;
  padding: 30px 0 30px;

  @media (max-width:${breakpoints.phone}px) {
    position: relative;
    width: 100%;
    left: 0;
    bottom: 0;
    margin-top: 10px;
    padding: 15px;
  }
`;

export const TotalsContainer = styled(FlexContainerRow)`
  padding-left: 10px;

  && {
    > * {
      margin-bottom: 0;
      font-size: 1.142em;
      font-weight: bold;

      &:last-child {
        text-align: right;

        .center {
          text-align: center
        }
      }
    }
  }
`;

export const SalesTaxContainer = styled(FlexContainerRow)`
  border-top: 1px solid ${COLORS.disabledGray};
  padding: 10px 0px 3px 10px;

  && {
    > * {
      margin-bottom: 0;
      margin-right: 0px;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        text-align: right;
        margin-right: 0;
      }
    }
  }
`;

export const DisclaimerText = styled.span`
  clear: both;
  display: block;
  margin-top: 10px;
  width: 100%;
`;

const CartInfoCss = css`
  background-color: ${COLORS.lighterBlueSdk};
  border-radius: 5px;
  width: 100%;
  margin-bottom: 30px;
  @media (min-width: 600px) {
    min-width: 480px;
  }
  border: 1px solid ${COLORS.lightestBlue};
`;

export const CartInfoContainer = styled.div`
  ${CartInfoCss}

  #cart-info-header {
    font-size: 30px;
  }

  .cart-info-text {
    font-size: 18px;
  }

  .cart-info-total {
    font-size: 20px;
  }

  & s-col {
    padding: 0;
    min-width: auto;
  }

  .no-wrap {
    white-space: nowrap;
  }

  .hide-overflow {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const QuantityWrapper = styled.div`

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance:textfield; /* Firefox */
    margin-bottom: 0;
    max-width: 30px;
    min-width: 30px;
    min-height: 30px;
    border-radius: 3px;
    font-size: 16px;
    text-align: center;
    &.error {
      border: 1px solid ${COLORS.alertRed};
    }
  }

  display: inline-flex;
  span {
    display: inline-flex;
    align-items: center;
    margin-left: 5px;
  }
`;
